"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _getCloudinaryImage = _interopRequireDefault(require("./getCloudinaryImage"));
var _excluded = ["src", "className", "width", "height", "crop", "innerRef", "extension", "inlineWidth", "inlineHeight"];
var Image = function Image(_ref) {
  var src = _ref.src,
    className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    crop = _ref.crop,
    innerRef = _ref.innerRef,
    extension = _ref.extension,
    inlineWidth = _ref.inlineWidth,
    inlineHeight = _ref.inlineHeight,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("img", Object.assign({
    className: className,
    width: inlineWidth,
    height: inlineHeight,
    src: (0, _getCloudinaryImage.default)({
      width: width,
      height: height,
      crop: crop,
      extension: extension
    })(src),
    ref: innerRef
  }, props));
};
Image.defaultProps = {
  width: null,
  height: null,
  crop: 'fill',
  className: '',
  extension: 'jpg',
  inlineWidth: null,
  inlineHeight: null
};
var _default = exports.default = Image;